webpackJsonp([273950069227526],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/about.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"id": "D:/projekty/Calipsy/src/pages/about.md absPath of file >>> MarkdownRemark",
				"frontmatter": {
					"title": "About",
					"banner": {
						"imageUrl": "/images/about/aboutbanner.jpg",
						"type": "small",
						"anchor": "center"
					}
				}
			}
		},
		"pathContext": {
			"path": "/about"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---about-c2e82b686d13636d5bfa.js